import { Pipe, PipeTransform } from '@angular/core';
import { LanguageModel } from "../../../services/akita/language-schema/language.model";


@Pipe({
  name: 'getLanguageCode'
})
export class GetLanguageCodePipe implements PipeTransform {
  transform(languageModel: LanguageModel): string {
    if (!languageModel || !languageModel.data) return '';
    return languageModel.data.code.iv;
  }
}
